/* CSS */
import "@css/app.scss";

/* JS */
document.documentElement.classList.remove('no-js');

/* Modules */
import { customiseModule } from './modules/customise';
import { imageSecurity } from './modules/imageSecurity';

/* Exports */
customiseModule();
imageSecurity();

/* Alpine JS */
import "./modules/alpine/index";
